"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _warning = _interopRequireDefault(require("warning"));

var _invariant = _interopRequireDefault(require("invariant"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _warningOnce = _interopRequireDefault(require("../_utils/warningOnce"));

var _Empty = _interopRequireDefault(require("../Empty"));

var _propTypes = _interopRequireDefault(require("@insolus/prop-types"));

var _isEmptyChildren = _interopRequireDefault(require("../_utils/isEmptyChildren"));

var _isShallowEquals = _interopRequireDefault(require("../_utils/isShallowEquals"));

var _reactI18n = require("@insolus/react-i18n");

var _Column = _interopRequireWildcard(require("./Column"));

var _utils = require("./_utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _normalizeColumns = function _normalizeColumns(columns, children) {
  var elements = children ? React.Children.toArray(children) : undefined;
  return (0, _utils.normalizeColumns)(columns, elements);
};

var Table = function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    (0, _classCallCheck2.default)(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      columns: []
    };

    _this.handleSortableClick = function (identifier) {
      return function () {
        var onOrderChange = _this.props.onOrderChange;

        if (!onOrderChange) {
          return;
        }

        var order = _this.props.order;
        var direction = 'asc';

        if (order && order.column === identifier) {
          direction = order.direction === 'asc' ? 'desc' : 'asc';
        }

        onOrderChange(identifier, direction);
      };
    };

    return _this;
  }

  (0, _createClass2.default)(Table, [{
    key: "_getRowKey",
    value: function _getRowKey(record, index) {
      var rowKey = this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record) : record[rowKey];
      var hasKey = key !== undefined;
      (0, _warningOnce.default)(hasKey, "Chaque enregistrement dans `<Table>` doit contenir une prop. `key` unique ou " + "vous pouvez faire pointer la prop. `rowKey` sur une cl\xE9 primaire unique.");
      return hasKey ? key : index;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this2 = this;

      var order = this.props.order;
      var columns = this.state.columns;

      if (!columns) {
        return null;
      }

      var cells = [];
      columns.forEach(function (column) {
        var key = column.key,
            type = column.type,
            sortable = column.sortable,
            className = column.className;
        var isSorted = sortable && order && order.column === key;
        var otherClassNames = [];

        if (type) {
          otherClassNames.push("Table__cell--".concat(type));
        }

        if (isSorted) {
          var _direction = order.direction.toLowerCase();

          otherClassNames.push("Table__cell--sorted-".concat(_direction));
        }

        var _className = _classnames2.default.apply(void 0, [className, 'Table__cell', {
          'Table__cell--sortable': sortable,
          'Table__cell--sorted': isSorted
        }].concat(otherClassNames));

        var cellProps = {
          children: column.title
        };

        if (column.colSpan || typeof column.colSpan === 'number') {
          if (column.colSpan === 0) {
            return;
          }

          cellProps.colSpan = column.colSpan;
        }

        if (column.align) {
          cellProps.style = {
            textAlign: column.align
          };
        }

        if (sortable) {
          cellProps.onClick = _this2.handleSortableClick(key);
        }

        cells.push(React.createElement("th", Object.assign({}, cellProps, {
          key: key,
          className: _className
        })));
      });
      return React.createElement("thead", {
        className: "Table__header"
      }, React.createElement("tr", {
        className: "Table__row"
      }, cells));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this3 = this;

      var columns = this.state.columns;
      var _this$props = this.props,
          data = _this$props.data,
          __ = _this$props.__;

      if (!data || !columns) {
        return null;
      }

      var rows = [];
      data.forEach(function (record, index) {
        var key = _this3._getRowKey(record, index);

        var cells = [];
        columns.forEach(function (column) {
          var _classnames;

          var path = column.path,
              type = column.type,
              render = column.render,
              _column$className = column.className,
              className = _column$className === void 0 ? '' : _column$className,
              emptyText = column.emptyText;
          var cell = {
            className: '',
            children: null
          };
          var text = null;

          if (path || typeof path === 'number') {
            text = (0, _get.default)(record, path);
          }

          if (render) {
            text = render(record, text, index);

            if (!(0, _utils.isValidCellText)(text)) {
              var CELL_FIELDS = ['children', 'className', 'colSpan', 'rowSpan', 'style'];

              var _pick = (0, _pick2.default)(text, CELL_FIELDS),
                  children = _pick.children,
                  _cell = (0, _objectWithoutProperties2.default)(_pick, ["children"]);

              cell = _objectSpread(_objectSpread({}, cell), _cell);
              text = children;
            }
          }

          (0, _invariant.default)((0, _utils.isValidCellText)(text), "La valeur point\xE9e par `column[path]` ou retourn\xE9e par `column[render]` " + "(ou `column[render].children`) dans `<Table>` doit pouvoir \xEAtre rendu par React.");
          cell.children = text;

          if (cell.rowSpan === 0 || cell.colSpan === 0) {
            return;
          }

          var isEmpty = (0, _utils.isEmptyNode)(cell.children);

          if (isEmpty && emptyText !== false) {
            (0, _invariant.default)(!(emptyText !== true && !(0, _utils.isValidCellText)(emptyText)), "La valeur de `column[emptyText]` doit pouvoir \xEAtre rendu par React.");
            cell.children = emptyText !== true ? emptyText : __('table.not-specified');
          }

          var _cell2 = cell,
              cellClassName = _cell2.className,
              cellProps = (0, _objectWithoutProperties2.default)(_cell2, ["className"]);

          var _className = (0, _classnames2.default)(className, cellClassName, 'Table__cell', (_classnames = {}, (0, _defineProperty2.default)(_classnames, "Table__cell--".concat(type), type), (0, _defineProperty2.default)(_classnames, 'Table__cell--empty', isEmpty), _classnames));

          if (column.align) {
            cellProps.style = _objectSpread(_objectSpread({}, cellProps.style || {}), {}, {
              textAlign: column.align
            });
          }

          cells.push(React.createElement("td", Object.assign({}, cellProps, {
            key: column.key,
            className: _className
          })));
        });
        rows.push(React.createElement("tr", {
          key: key,
          className: "Table__row"
        }, cells));
      });
      return React.createElement("tbody", {
        className: "Table__body"
      }, rows);
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var columns = this.state.columns;

      if (!columns) {
        return null;
      }

      var cols = columns.map(function (_ref) {
        var key = _ref.key,
            width = _ref.width;
        return React.createElement("col", {
          key: key,
          style: {
            width: width,
            minWidth: width
          }
        });
      });
      return React.createElement("table", {
        className: "Table__table"
      }, React.createElement("colgroup", null, cols), this.renderHeader(), this.renderBody());
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _this$props2 = this.props,
          emptyText = _this$props2.emptyText,
          data = _this$props2.data;

      if (data && data.length) {
        return null;
      }

      var emptyProps = {
        description: undefined,
        children: undefined
      };

      if (emptyText && typeof emptyText === 'object' && (typeof emptyText.footer !== 'undefined' || typeof emptyText.description !== 'undefined')) {
        emptyProps.description = emptyText.description;
        emptyProps.children = emptyText.footer;
      } else {
        emptyProps.description = emptyText;
      }

      return React.createElement(_Empty.default, Object.assign({
        className: "Table__empty"
      }, emptyProps));
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return React.createElement("div", {
        className: (0, _classnames2.default)(className, 'Table')
      }, this.renderTable(), this.renderEmpty());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      (0, _warning.default)(!(nextProps.columns && nextProps.children && !(0, _isEmptyChildren.default)(nextProps.children)), "Vous ne devriez pas utiliser la prop. `columns` et sp\xE9cifier les colonnes en " + "tant que children en m\xEAme temps sur un m\xEAme `<Table>`, les colonnes en tant " + "que children vont \xEAtre ignor\xE9es.");

      if (nextProps.columns !== undefined || nextProps.children !== undefined) {
        var columns = _normalizeColumns(nextProps.columns, nextProps.children);

        if (!(0, _isShallowEquals.default)(columns, state.columns)) {
          return {
            columns: columns
          };
        }
      }

      return null;
    }
  }]);
  return Table;
}(React.Component);

Table.Column = _Column.default;
Table.defaultProps = {
  columns: undefined,
  data: [],
  rowKey: 'key',
  emptyText: undefined,
  order: undefined,
  onOrderChange: undefined,
  className: undefined,
  children: undefined
};

var _translate = (0, _reactI18n.translate)('ui-kit');

var _default = _translate(Table);

exports.default = _default;